import { Box, Spinner, Text, Select } from "@chakra-ui/react";
import DataTableV2 from "components/DataTable/DateTableV2";
import React, { useState } from "react";
import { formatDate } from "utils";
import { useRightSidebar } from "context/RightSidebarContext";
import AITaskDetailsPanel from "./AITaskDetailsRSidebar";
import { useQuery } from "react-query";
import { H1 } from "components/text/headings";
import { taskService, apiGetTaskRunnerStatus } from "api/ai/ai.service";
import AIProgressWidget from "./AIProgressWidget";
import { useSelector } from "react-redux";

/**
 * List of AI Tasks for debugging / internal use
 * @returns
 */
export default function AITasksListPanel() {
  const { setRightSidebar, doOpen } = useRightSidebar();
  const [statusFilter, setStatusFilter] = useState("all");
  // Get the list of tasks
  // NB: just 20 as the full list can get slow (see ESG-3417)
  const { data: aiTasks, isLoading } = useQuery(["apiListTasks", statusFilter], 
	() => taskService.list({ size: 20, query: statusFilter === "all" ? undefined : 'status:'+statusFilter }), {
    cacheTime: 0,
    refetchInterval: 10000,
  });

//   const { data: aiTaskRunnerStatus } = useQuery(["apiGetTaskRunnerStatus"], () => apiGetTaskRunnerStatus(), {
//     cacheTime: 0,
//     refetchInterval: 10000,
//   });
//   console.log(aiTaskRunnerStatus); // for debug

  const roundSelector = useSelector((state) => state.issbRound);
  const rounds = roundSelector?.roundList;
  const name4round = (roundId) => {
    const round = rounds.find((r) => r.id === roundId);
    return round?.name;
  };

  const openSidebar = (item) => {
    setRightSidebar(<AITaskDetailsPanel task={item} />);
    doOpen();
  };

  /** @type {ColumnDef[]} */
  const columns = [
    {
      header: "id",
      accessorKey: "id",
      cell: ({ row }) => <Text onClick={() => openSidebar(row.original)}>{row.original.id}</Text>,
      size: 250,
    },
    {
      header: "Label",
      accessorKey: "name",
      size: 200,
    },
    {
      header: "Round",
      accessorKey: "round_id",
      accessorFn: (row) => name4round(row.round_id) || row.round_id,
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      size: 100,
    },
    {
      header: "Progress",
      // accessorKey: "progress",
      cell: ({ row }) => <AIProgressWidget task={row.original} refetchInterval={5000} />,
      size: 100,
    },
    {
      header: "Type",
      size: 150,
      accessorKey: "task_type",
    },
    {
      header: "Created date",
      size: 100,
      accessorFn: (file) => formatDate(file.created_date),
    },
    {
      header: "Completed date",
      size: 100,
      accessorFn: (file) => formatDate(file.completed_date),
    },
  ];


  return (
    <Box>
      <H1>Tasks</H1>
	  <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
	{["all", "done", "running", "queued", "failed", "cancelled"].map((status) => <option value={status}>{status}</option>)}
	</Select>
      {!aiTasks && isLoading && <Spinner width={"100px"} height={"100px"} />}
      {aiTasks && (
        <DataTableV2
          columns={columns}
          data={aiTasks}
          isLoading={isLoading}
          serverSidePagination={false} // TODO what happens if there are 1000 files?
          showPaginator={false} // TODO what happens if there are 1000 files?
        />
      )}
    </Box>
  );
}
